module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "botTableWrap"
  }, [_c('div', {
    staticClass: "componentWrap date_comp"
  }, [_c('div', {
    staticClass: "bot_label"
  }, [_c('v-icon', [_vm._v("today")]), _vm._v("일자별 리포트")], 1), _vm._v(" "), _c('div', {
    staticClass: "table_wrap"
  }, [_c('table', {
    staticClass: "bottom"
  }, [_c('DaysImp', {
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "headers": _vm.headers,
      "isCreative": _vm.isCreative,
      "isExcel": _vm.isExcel,
      "tab": _vm.tab
    }
  }), _vm._v(" "), _c('DaysTotal', {
    attrs: {
      "campaignType": _vm.campaignType,
      "campaginDaysData": _vm.campaginDaysData,
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "dataInfo": _vm.dataInfo,
      "isExcel": _vm.isExcel,
      "tab": _vm.tab
    }
  })], 1)])]), _c('ContentImp', {
    attrs: {
      "headers": _vm.headers,
      "isExcel": _vm.isExcel,
      "tab": _vm.tab
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-723f2408","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/campaignBotTable/dateTable.vue
// module id = 860
// module chunks = 1